import { render, staticRenderFns } from "./SecondTemplate.vue?vue&type=template&id=6daaecb6&scoped=true&"
import script from "./SecondTemplate.vue?vue&type=script&lang=js&"
export * from "./SecondTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SecondTemplate.vue?vue&type=style&index=0&id=6daaecb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daaecb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VRow})
